<template>
  <div>
    <div class="ui-pannel">
      <div class="title">
        <p class="txt">{{ $t('user.myTimetable') }}</p>
        <!-- <div class="countdown" v-if="false">距离开课时间：2小时34分56秒</div> -->
      </div>
      <div class="content">
        <div class="course" v-if="recentCourse.length">
          <span class="name">Course{{ $t('colon') }} {{ recentCourse[0].courseName }}</span>
          <span class="tutor">Tutor{{ $t('colon') }} {{ recentCourse[0].teacherName }}</span>
          <span class="time">{{ getTime1(recentCourse[0]) }}</span>
          <a class="btn-enter" @click="goToRoom(recentCourse[0])"
            >Start Lesson</a
          >
        </div>
        <div class="topic-box">
          <a class="pre" @click="changeDate(1)">{{ $t('weeks.pre') }}</a>
          <p class="topic">{{ $t('weeks.title') }}</p>
          <a class="next" @click="changeDate(2)">{{ $t('weeks.next') }}</a>
        </div>
        <ul class="dates">
          <li v-for="item in dateArr" :key="item.week">
            <span v-if="item.show === $t('weeks.today')">
              <p class="week">{{ item.show }}</p>
              <p class="date">{{ item.date }}</p>
            </span>
            <span v-else>
              <p class="week">{{ item.week }}</p>
              <p class="date">{{ item.show }}</p>
            </span>
          </li>
        </ul>
        <ul ref="times" class="times">
          <li v-for="(item, i) in bookArr" :key="i">
            <div
              :class="{
                finished: cell.state === 8,
                success: cell.state === 1 || cell.state === 5,
                waiting: cell.state === 7 || cell.state === 0,
              }"
              class="courseinfo"
              v-for="(cell, j) in item"
              :key="j"
              :style="getTop(cell.beginTime)"
            >
              <p class="time">
                {{ getTime(cell.beginTime) }}-{{ getTime(cell.endTime) }}
              </p>
              <p class="info">{{ cell.teacherName }}({{ cell.courseName }})</p>
              <div class="btns" v-if="cell.state === 2 || cell.state === 9">
                <a class="btn courseware" @click="showCourseInfo(i, j)"></a>
                <a class="btn exchange" @click="showComment(i, j)"></a>
              </div>
              <div class="btns" v-if="cell.state === 1 || cell.state === 5">
                <a class="btn courseware" @click="showCourseInfo(i, j)"></a>
                <router-link
                  v-if="cell.state === 1"
                  :to="{
                    path: '/user/rebook',
                    query: { id: cell.teacherId,orderCourseId:cell.id, time: cell.beginTime },
                  }"
                  class="btn edit"
                ></router-link>
                <a class="btn delete" @click="delCourse(i, j)"><i class="el-icon-circle-close"></i></a>
              </div>
              <div class="btns" v-if="cell.state === 7 || cell.state === 0">
                <router-link
                  :to="{ path: '/order', query: { id: cell.orderCode } }"
                  class="btn money"
                ></router-link>
                <a class="btn delete">
                  <i class="el-icon-circle-close" @click="delCourse(i, j)"></i>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <update
      :course="bookArr[idx.x][idx.y]"
      :info="courseInfo"
      v-if="courseInfo.show"
    />
    <comfirm
      @submit="comfirmNext"
      @cancel="comfirmCancel"
      :info="comfirmInfo"
    />
    <comment :info="commentInfo" />
  </div>
</template>
<script>
import {
  getCoursewareList,
  delOrderCourse,
  getRecentOrderCourse,
} from '@/service/api.js'
import {
  getStudentStudyCourseList,
  getMyInvitedCourseList,
} from '@/service/studentApi.js'
import update from '@/components/UpdateCourse.vue'
import comfirm from '@/components/Comfirm.vue'
import comment from '@/components/PopComment.vue'
import moment from 'moment'
import { roomUrl  } from '@/service/env'
export default {
  components: { update, comfirm, comment },
  data() {
    return {
      currentDay: '',
      dateArr: [
        { date: '', show: '', week: this.$t('weeks.mon') },
        { date: '', show: '', week: this.$t('weeks.tues') },
        { date: '', show: '', week: this.$t('weeks.wed') },
        { date: '', show: '', week: this.$t('weeks.thur') },
        { date: '', show: '', week: this.$t('weeks.fri') },
        { date: '', show: '', week: this.$t('weeks.sat') },
        { date: '', show: '', week: this.$t('weeks.sun') },
      ],
      courseInfo: { show: false },
      idx: { x: 0, y: 0 },
      form: '',
      bookArr: [[]],
      comfirmInfo: {
        show: false,
        title: this.$t('common.tip'),
        topic: this.$t('common.comfirmSingerCourse'),
        desc: this.$t('common.comfirmInfoDesc'),
        cancel: this.$t('cancel'),
        comfirm: this.$t('common.submit'),
      },
      commentInfo: { show: false, data: {} },
      recentCourse: [],
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  created() {

    this.$nextTick(() => {
      this.$refs.times.scrollTop = 1120
    })
    this.currentDay = moment().format('YYYYMMDD')
    this.resetDate()
    this.getStudentStudyCourseList()
    this.getRecentCourse()
  },
  methods: {
    getTime1(item) {
      return (
        moment(item.beginTime * 1000).format('DD/MM/YYYY HH:mm - ') +
        moment(item.endTime * 1000).format('HH:mm')
      )
    },
    resetDate() {
      let day = moment(this.currentDay).format('d')
      if (day == 0) {
        day = 7
      }
      for (let i = 0; i < 7; i++) {
        this.dateArr[i].date = moment(this.currentDay)
          .subtract(day - i - 1, 'day')
          .format('YYYY-MM-DD')
        if (
          moment(this.dateArr[i].date).format('YYYYMMDD') ===
          moment().format('YYYYMMDD')
        ) {
          this.dateArr[i].show = this.$t('weeks.today')
          this.dateArr[i].date = moment(this.dateArr[i].date).format('DD/MM')
        } else {
          this.dateArr[i].show = moment(this.dateArr[i].date).format('DD/MM')
        }
      }
    },
    changeDate(type) {
      if (type === 1) {
        this.currentDay = moment(this.currentDay)
          .subtract(7, 'day')
          .format('YYYYMMDD')
      } else {
        this.currentDay = moment(this.currentDay)
          .add(7, 'day')
          .format('YYYYMMDD')
      }
      this.resetDate()
      this.getStudentStudyCourseList()
      this.$forceUpdate()
    },
    async getCoursewareList() {
      const res = await getCoursewareList()
      if (res.data.status === 1) {
        this.form = res.data.data
      }
    },
    async getRecentCourse() {
      // const res = await getRecentOrderCourse({studentId: this.user.uid})
      // if(res.data.status === 1){
      //   this.recentCourse = res.data.data
      //   console.log(this.recentCourse)
      // }
      this.recentCourse=[];
      const res = await getStudentStudyCourseList({
        state: 6,
        pageNO: 1,
        pageSize: 1,
      })
      if (res.data.status === 1) {
        // console.log(res.data.data)
        this.recentCourse = res.data.data
      }
      if (this.recentCourse.length === 0) {
        const res = await getStudentStudyCourseList({
          state: 51,
          pageNO: 1,
          pageSize: 1,
        })
        if (res.data.status === 1) {
          this.recentCourse = res.data.data
        }
      }
    },
    async getStudentStudyCourseList() {
      const res = await getStudentStudyCourseList({
        beginTime: moment(this.dateArr[0].date).format('X'),
        endTime: moment(this.dateArr[6].date).endOf('date').format('X'),
      })
      if (res.data.status === 1) {
        // console.log(res.data.data);
        this.bookArr = [[], [], [], [], [], [], []]
        for (let i = 0; i < res.data.data.length; i++) {
          for (let j = 0; j < 7; j++) {
            // console.log(moment(res.data.data[i].beginTime * 1000).format("YYYYMMDD"));
            if (
              moment(res.data.data[i].beginTime * 1000).format('YYYYMMDD') ==
              moment(this.dateArr[j].date).format('YYYYMMDD')
            ) {
              this.bookArr[j].push(res.data.data[i])
            } else if (
              moment(this.dateArr[j].date, 'DD/MM').format('YYYYMMDD') ==
              moment(res.data.data[i].beginTime * 1000).format('YYYYMMDD')
            ) {
              this.bookArr[j].push(res.data.data[i])
            }
          }
        }
      }
      // console.log(moment(this.dateArr[0].date).format('X')*1000);
      //  console.log(this.dateArr[6].date);
      // const res2 = await getMyInvitedCourseList({pageNO: 1,pageSize:999})
      // if(res2.data.status === 1){
      //   console.log(res2.data.data)
      // }
    },
    showCourseInfo(i, j) {
      this.courseInfo.show = true
      this.idx = { x: i, y: j }
    },
    getTop(time) {
      const h = moment(time * 1000).format('H')
      const m = moment(time * 1000).format('m')
      return { top: h * 145 + 'px' }
    },
    getTime(time) {
      return moment(time * 1000).format('HH:mm')
    },
    delCourse(i, j) {
      this.idx = { x: i, y: j }
      this.comfirmInfo.show = true
    },
    async comfirmNext() {
      const res = await delOrderCourse({
        orderCourseId: this.bookArr[this.idx.x][this.idx.y].id,
      })
      if (res.data.status === 1) {
        this.$message({ type: 'success', message: '取消成功' })
        this.comfirmInfo.show = false
        this.bookArr[this.idx.x].splice(this.idx.y, 1)
      }
    },
    comfirmCancel() {
      this.comfirmInfo.show = false
    },
    showComment(i, j) {
      this.commentInfo.show = true
      this.idx = { x: i, y: j }
      this.commentInfo.data = this.bookArr[this.idx.x][this.idx.y]
      // console.log(this.commentInfo.data)
    },
    goToRoom(course) {
      let locale = this.$i18n.locale
      switch (locale) {
        case 'cn':
          locale = 'zh-CN'
          break
        case 'TW':
          locale = 'zh-HK'
          break
      }
      const { teacherId, id, courseName, beginTime, endTime } = course
      window.open(
        `${roomUrl}/?locale=${locale}&teacher_id=${teacherId}&order_course_id=${id}&course_name=${courseName}&begin_time=${beginTime}&end_time=${endTime}&token=${sessionStorage.getItem('1to1token')}#/init`
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  .txt {
    flex: 1;
  }
  .countdown {
    font-weight: normal;
    font-size: 16px;
    color: #333;
  }
}
.content {
  padding: 40px 50px;
}
.course {
  height: 50px;
  background: rgba(0, 33, 71, 0.1);
  font-size: 16px;
  color: #333;
  display: flex;
  padding: 0 50px;
  align-items: center;
  .name {
    min-width: 260px;
    padding-right: 20px;
  }
  .tutor {
    flex: 1;
  }
  .btn-enter {
    display: inline-block;
    padding: 0 12px;
    height: 30px;
    border-radius: 5px;
    background: #002147;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    margin-left: 20px;
  }
}
.topic-box {
  height: 100px;
  border-bottom: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  .topic {
    font-size: 18px;
    line-height: 42px;
    text-align: center;
    flex: 1;
    font-weight: bold;
  }
}
.pre,
.next {
  height: 42px;
  font-size: 16px;
  color: #666;
  line-height: 42px;
}
.pre {
  float: left;
  padding-left: 49px;
  background: url(../assets/arrow_left.png) no-repeat left center;
}
.next {
  float: right;
  padding-right: 49px;
  background: url(../assets/arrow_right.png) no-repeat right center;
}
.dates {
  overflow: hidden;
  height: 95px;
  border-bottom: 1px solid #d6d6d6;
  padding: 16px 37px 0;
  li {
    float: left;
    margin: 0 4px;
    width: 100px;
    text-align: center;
    font-size: 16px;
  }
  .date {
    color: #666;
    margin-top: 5px;
  }
}
.times {
  overflow: hidden;
  padding: 0 37px;
  overflow-y: auto;
  height: 540px;
  display: flex;
  li {
    flex: 1;
    width: 100px;
    margin: 0 4px;
    padding: 20px 0;
    float: left;
    text-align: center;
    color: #666;
    line-height: 30px;
    position: relative;
    min-height: 3470px;
  }
  li:nth-child(2n + 1) {
    background: #ebebeb;
  }
  li:nth-child(2n) {
    background: #8a8a8a;
  }
}
.courseinfo {
  position: absolute;
  left: 0;

  font-size: 12px;
  color: #fff;
  background: #777;
  width: 100px;
  text-align: center;
  // padding: 32px 0 0;
  line-height: 16px;
  padding-top: 12px;
  height: 135px;
  &.success {
    background: #002147;
  }
  &.waiting {
    background: #ff0068;
  }
  p {
    margin-bottom: 5px;
  }
  .btns {
    margin-top: 10px;
  }
  .btn {
    display: inline-block;
    width: 20px;
    height: 16px;
    margin: 0 5px;
    vertical-align: top;
  }
  .courseware {
    background: url(../assets/course.png) no-repeat center center;
  }
  .exchange {
    background: url(../assets/exchange.png) no-repeat center center;
  }
  .edit {
    background: url(../assets/edit.png) no-repeat center center;
  }
  .money {
    background: url(../assets/money.png) no-repeat center center;
  }
  .delete i {
    font-size: 16px;
  }
}
</style>